(() => {
    
    

    window.klaviyoLists = {
        newsletter:window.KLAVIYO_LIST_ID_NEWSLETTER,
        notify: window.KLAVIYO_LIST_ID_NOTIFY
    }

    window.klaviyoPayload = ({ list = "", source = "", email = "", properties = {} } = {}) => ({
        data: {
            type: "subscription",
            attributes: {
                custom_source: source,
                profile: {
                    data: {
                        type: "profile",
                        attributes: {
                            subscriptions: {
                                email: {
                                    marketing: {
                                        consent: "SUBSCRIBED",
                                    },
                                },
                                sms: {
                                    marketing: {
                                        consent: "SUBSCRIBED",
                                    },
                                    transactional: {
                                        consent: "SUBSCRIBED",
                                    },
                                },
                                whatsapp: {
                                    marketing: {
                                        consent: "SUBSCRIBED",
                                    },
                                    transactional: {
                                        consent: "SUBSCRIBED",
                                    },
                                },
                            },
                            email: email,
                            properties: properties,
                        },
                    },
                },
            },
            relationships: {
                list: {
                    data: {
                        type: "list",
                        id: list,
                    },
                },
            },
        },
    });

    window.klaviyoSend = (data) => {
        return new Promise((resolve, reject) => {
            const headers = new Headers();
            headers.append("accept", "application/vnd.api+json");
            headers.append("content-type", "application/vnd.api+json");
            headers.append("revision", "2025-10-15");

            const requestOptions = {
                method: "POST",
                headers: headers,
                body: JSON.stringify(data),
            };

        fetch(`https://a.klaviyo.com/client/subscriptions?company_id=${window.KLAVIYO_ID}`, requestOptions)
        .then((response) => response.text())
        .then((result) => {
            resolve(result)
        })
        .catch((error) => reject(error));

        })
    }

})();
